import { FC } from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { SimpleExpression } from '../../models/expression';
import { ExpressionPreviewFull } from './ExpressionPreviewFull';

interface ExpressionDialogProps {
  visible: boolean;
  onHide: () => void;
  expression: SimpleExpression | null;
}

export const ExpressionDialog: FC<ExpressionDialogProps> = ({
  visible,
  onHide,
  expression,
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Expression Details"
      modal
      style={{ width: '900px', maxWidth: '90vw' }}
    >
      <TabView>
        <TabPanel header="Condition Preview">
          <div style={{ maxHeight: '600px', overflow: 'auto', padding: '1rem' }}>
            <ExpressionPreviewFull 
              expression={expression} 
              style={{ fontSize: '1rem' }}
            />
          </div>
        </TabPanel>
        <TabPanel header="JSON">
          <pre 
            className="bg-gray-100 p-3 border-round overflow-auto" 
            style={{ maxHeight: '600px', fontSize: '0.875rem' }}
          >
            {JSON.stringify(expression, null, 2)}
          </pre>
        </TabPanel>
      </TabView>
    </Dialog>
  );
};
